import { render, staticRenderFns } from "./FeedTankAlertsSection.vue?vue&type=template&id=ef8b7d5c&"
import script from "./FeedTankAlertsSection.vue?vue&type=script&lang=ts&"
export * from "./FeedTankAlertsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports